import React, {useRef, useState} from 'react';
import {connect} from 'react-redux';
import {setShowPopUp, submitClosingFU} from '../BusinessWorkOrderSystemSlice';
import TextArea from 'app/Components/Shared/TextArea/TextArea';
import {formatDateString14digits, formatTimeString14digits} from 'app/utilities/StringHelpers/StringHelpers';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';

const CloseFU = (props) => {
  //const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState(false);

  function submitClose() {
    if (inputValue?.trim())
      props.submitClosingFU({
        FuId: props.businessWorkOrderSystem.currentPopupData?.fuId,
        FuBan: props.businessWorkOrderSystem.currentPopupData?.fuBan,
        CloseReason: inputValue,
      });
    else {
      setError(true);
    }
  }

  function validateLengthAndSetInputValue(value) {
    if (value.length > 500) {
      return null;
    } else {
      setInputValue(value);
    }
  }
  return (
    <div className='fu-details-container'>
      <div className='l-title'>
        סגירת הוראת עבודה <br />
        פניה מספר {props.businessWorkOrderSystem.currentPopupData?.fuId}{' '}
      </div>
      <div className='fu-details'>
        <div className='general-data'>
          <div className='general-fu-data'>
            <div className='general-fu-data-column'>
              <div className='fu-data-item'>
                <div className='fu-data-label'>פותח הפניה </div>
                <div className='fu-data-value'>{props.businessWorkOrderSystem.currentPopupData?.openedBy || '----'}</div>
              </div>
              <div className='fu-data-item'>
                <div className='fu-data-label'> סוג הפניה</div>
                <div className='fu-data-value'>{props.businessWorkOrderSystem.currentPopupData?.futpSystemTxt}</div>
              </div>
            </div>
            <div className='general-fu-data-column'>
              <div className='fu-data-item'>
                <div className='fu-data-label'> תאריך פתיחה</div>
                <div className='fu-data-value'>{formatDateString14digits(props.businessWorkOrderSystem.currentPopupData?.fuOpenDate)}</div>
              </div>

              <div className='fu-data-item'>
                <div className='fu-data-label'>שעת פתיחה</div>
                <div className='fu-data-value'>{formatTimeString14digits(props.businessWorkOrderSystem.currentPopupData?.fuOpenDate)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='fu-details'>
        <div className='general-data'>
          <div className='general-fu-data'>
            <div className='general-fu-data-column'>
              <div className='fu-data-item'>
                <div className='fu-data-value'>סיבת הסגירה</div>
                <div className='fu-data-label text-area-container'>
                  <TextArea
                    // ref={inputRef}
                    value={inputValue}
                    placeholder={'פירוט סיבת הסגירה*'}
                    onChange={(value) => {
                      setError(false);
                      validateLengthAndSetInputValue(value);
                    }}
                  />
                  <div className='character-counter'>{inputValue.length}/500 תווים</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='btn-submit-container'>
        {error && <div className='error-message'>סיבת הסגירה היא שדה חובה</div>}
        <BtnSubmit onclick={() => submitClose()} className='btn-submit-close-fu' text={'סגירת הפניה'} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});
const mapDispatchToProps = {setShowPopUp, submitClosingFU};

export default connect(mapStateToProps, mapDispatchToProps)(CloseFU);
